import React from "react";
import { StatusBarTargetContext } from "./StatusBarTargetContext";
import { StatusBarZoomContextProvider } from "./StatusBarZoomContext";
import { StatusBarCustomizationContextProvider } from "./StatusBarCustomizationContext";

type StatusBarContextProviderProps = React.PropsWithChildren<{
    // The DOM element where status-bar items are rendered through portals.
    target: HTMLDivElement | null;
}>;

// Shares status-bar data and preferences with module items rendered through portals.
export const StatusBarContextProvider: React.FunctionComponent<StatusBarContextProviderProps> = ({ children, target, }) => (<StatusBarTargetContext.Provider value={target}>
        <StatusBarCustomizationContextProvider>
            <StatusBarZoomContextProvider>{children}</StatusBarZoomContextProvider>
        </StatusBarCustomizationContextProvider>
    </StatusBarTargetContext.Provider>);
